import { render } from "./AgnNav.vue?vue&type=template&id=5877cc5e"
import script from "./AgnNav.vue?vue&type=script&lang=js"
export * from "./AgnNav.vue?vue&type=script&lang=js"

import "./AgnNav.vue?vue&type=style&index=0&id=5877cc5e&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__